import { Loader2 } from "lucide-react";

export const PageState = ({ loading, error, message }) => {
  if (loading) {
    return (
      <div className="flex items-center gap-3 py-16 text-ink-muted" role="status" data-testid="page-loading">
        <Loader2 className="h-5 w-5 animate-spin text-navy" aria-hidden="true" /> Yükleniyor…
      </div>
    );
  }
  if (error) {
    return (
      <p className="rounded-md border border-line bg-paper px-5 py-4 text-ink-soft" role="alert" data-testid="page-error">
        {message || "İçerik şu anda yüklenemedi. Lütfen daha sonra tekrar deneyin."}
      </p>
    );
  }
  return null;
};
